<template>
  <sui-menu attached inverted :color="config.offline ? 'grey' : 'blue'">
    <sui-menu-menu position="left">
      <router-link class="item" :class="{active: isDashboardPage}" to="/">
        <img class="menu-img" src="../assets/logo.svg" alt="Dashboard" />
      </router-link>
      <sui-dropdown :class="{disabled: isSubscriptionExpired}" item :icon="null" v-if="token">
        <i class="responsive-icon plus square large fitted icon" />
        <span class="responsive-text">Create</span>
        <i class="responsive-dropdown dropdown icon" />
        <sui-dropdown-menu class="create-menu" simple>
          <router-link class="item" :class="{disabled: !access.serviceCreate}" to="/new-service" data-goal="MENU_CREATE_SERVICE">
            <i class="window maximize icon" />
            Service
          </router-link>
          <router-link class="item" :class="{disabled: !access.serviceCreate}" to="/new-stack" data-goal="MENU_CREATE_STACK">
            <i class="briefcase icon" />
            Stack
          </router-link>
          <div class="item" :class="{disabled: !access.projectCreate}" data-goal="MENU_CREATE_PROJECT" @click="$modals.createProject.open()">
            <i class="folder icon" />
            Project
          </div>
          <div class="item" :class="{disabled: !access.hostCreate}" data-goal="MENU_CREATE_HOST" @click="$modals.createHost.open()">
            <i class="server icon" />
            Host
          </div>
          <div class="item" :class="{disabled: !access.keyCreate}" data-goal="MENU_CREATE_KEY" @click="$modals.createKey.open()">
            <i class="key icon" />
            Key
          </div>
          <div class="item" :class="{disabled: !access.providerCreate}" data-goal="MENU_CREATE_PROVIDER" @click="$modals.createProvider.open()">
            <i class="cloud icon" />
            Provider
          </div>
        </sui-dropdown-menu>
      </sui-dropdown>
      <sui-dropdown :class="{disabled: isSubscriptionExpired}" item :icon="null" v-if="token">
        <i class="responsive-icon pen large fitted icon" />
        <span class="responsive-text">Manage</span>
        <i class="responsive-dropdown dropdown icon" />
        <sui-dropdown-menu class="manage-menu" simple>
          <router-link class="item" to="/account/accounts" data-goal="MENU_MANAGE_ACCOUNTS">
            <i class="user circle icon" />
            <span class="text">Accounts</span>
            <span class="description">{{accounts.length}}</span>
          </router-link>
          <router-link class="item" to="/account/members" data-goal="MENU_MANAGE_MEMBERS">
            <i class="users icon" />
            <span class="text">Members</span>
            <span class="description">{{members.length}}</span>
          </router-link>
          <router-link class="item" to="/account/roles" data-goal="MENU_MANAGE_ROLES">
            <i class="tags icon" />
            <span class="text">Roles</span>
            <span class="description">{{roles.length}}</span>
          </router-link>
          <router-link class="item" to="/account/keys" data-goal="MENU_MANAGE_KEYS">
            <i class="key icon" />
            <span class="text">Keys</span>
            <span class="description">{{keys.length}}</span>
          </router-link>
          <router-link class="item" to="/account/providers" data-goal="MENU_MANAGE_PROVIDERS">
            <i class="cloud icon" />
            <span class="text">Providers</span>
            <span class="description">{{providers.length}}</span>
          </router-link>
        </sui-dropdown-menu>
      </sui-dropdown>
    </sui-menu-menu>

    <sui-menu-menu position="right">
      <router-link class="active item" to="/user/login" v-if="!token">
        <i class="sign in icon" />
        Log&nbsp;in
      </router-link>
      <div class="active item" v-if="token && !connected">
        <i class="circle notch loading icon" />
        Loading...
      </div>
      <sui-dropdown item button :icon="null" v-if="token && connected">
        <Logo class="responsive-icon fitted menu-img" :src="account.avatar" :email="account.email" />
        <div class="responsive-text">
          <div class="email">{{user.email}}</div>
          <div class="account" v-if="hasAccounts">{{account.name}}</div>
        </div>
        <i class="responsive-dropdown dropdown icon" />
        <sui-dropdown-menu class="user-menu" >
          <template v-if="hasAccounts">
            <sui-dropdown-header>Accounts</sui-dropdown-header>
            <sui-dropdown-item v-for="acc in accounts" :active="acc.id === account.id" :key="acc.id" @click="use(acc)" data-goal="MENU_USER_SELECT_ACCOUNT">
              <Logo class="avatar" :src="acc.avatar" :email="acc.email" square />
              <span class="text">{{acc.name}}</span>
              <span class="description">{{tariffsById[acc.tariff].name}}</span>
            </sui-dropdown-item>
            <sui-dropdown-divider />
          </template>
          <sui-dropdown-header>Settings</sui-dropdown-header>
          <router-link class="item" :class="{active: $route.path === '/settings/general'}" to="/settings/general" data-goal="MENU_USER_GENERAL_SETTINGS">
            <i class="columns icon" />
            <span class="text">General</span>
          </router-link>
          <!--<router-link class="item" :class="{active: $route.path === '/settings/plans'}" to="/settings/plans" data-goal="MENU_USER_PLANS_SETTINGS">
            <i class="money check alternate icon" />
            <span class="text">Plans</span>
          </router-link>
          <router-link class="item" :class="{active: $route.path === '/settings/payments', disabled: !access.tariffManagement}" to="/settings/payments" data-goal="MENU_USER_PAYMENTS_SETTINGS">
            <i class="receipt icon" />
            <span class="text">Payments</span>
          </router-link>-->
          <router-link class="item" :class="{active: $route.path === '/settings/security'}" to="/settings/security" data-goal="MENU_USER_SECURITY_SETTINGS">
            <i class="shield icon" />
            <span class="text">Security</span>
          </router-link>
          <sui-dropdown-divider />
          <sui-dropdown-item icon="red sign out" @click="logout()" data-goal="MENU_USER_LOGOUT">Log&nbsp;out</sui-dropdown-item>
        </sui-dropdown-menu>
      </sui-dropdown>
    </sui-menu-menu>
  </sui-menu>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'

  export default {
    name: 'MainMenu',
    data() {
      return {
        patchnoteIndex: 22,
        patchnoteTitle: 'Performance, support form, API docs',
        patchnoteLink: 'https://d2c.io/updates/front-end-optimization-new-ticket-form-api-docs-and-more',
      }
    },
    computed: {
      ...mapState(['connected', 'token', 'version']),
      ...mapGetters(['access', 'account', 'accounts', 'config', 'keys', 'member', 'members', 'providers', 'roles', 'tariff', 'tariffsById', 'user']),
      isDashboardPage() {
        return this.$route.path === '/dashboard'
      },
      isSubscriptionExpired() {
        return !this.account._isFree && !this.account._isActiveSubscriber
      },
      isPatchnoteVisible() {
        const userData = this.user.data
        return userData && (!userData.hidePatchnote || userData.hidePatchnote < this.patchnoteIndex)
      },
      hasAccounts() {
        return this.accounts.length > 1
      },
    },
    methods: {
      use(account) {
        account.use()
        this.$router.push(this.config.homePath).catch(() => {})
      },
      logout() {
        this.$store.dispatch('logout')
        this.$router.push('/user/login')
      },
      readPatchnote() {
        this.user.updateData({hidePatchnote: this.patchnoteIndex})
      },
    },
  }
</script>

<style scoped>
  .create-menu { font-size: 1.1em!important; }
  .help-menu { width: 220px; display: none!important; }
  .help-menu .item.item.item.item.item.item.item { display: flex!important; align-items: center; font-size: .9em!important; }
  .help-menu >>> .icon.icon.icon.icon.icon.icon.icon { float: left; font-size: 2em!important; margin-right: .3em!important }
  .help-menu >>> .icon.icon.icon.icon.icon.icon.icon:before { vertical-align: text-bottom!important; }
  .help-menu .price { color: #999!important; }
  .active .help-menu { display: flex!important; }
  .user-menu { left: auto!important; min-width: 200px!important; }
  .item { font-weight: bold!important; display: flex!important; align-items: center; }
  .item .text { flex: 1; }
  .menu-img { margin: 0!important; vertical-align: middle!important; height: 2em!important; width: auto!important; }
  .account { color: #fc6; font-size: .8em; }
  .avatar { height: 2em!important; width: 2em!important; }
  @media only screen and (max-width: 769px) {
    .responsive-icon { display: inline-block; }
    .responsive-text { display: none; }
    .responsive-dropdown { display: none; }
  }
  @media only screen and (min-width: 769px) {
    .responsive-icon.fitted { margin-right: .3em!important; }
    .responsive-icon.plus { display: none; }
    .responsive-icon.pen { display: none; }
    .responsive-icon.book { display: none; }
    .responsive-icon.question { display: none; }
    .responsive-icon.comment { display: none; }
    .responsive-text { display: inline-block; }
    .responsive-dropdown { display: block; }
  }
  @media only screen and (max-width: 450px) {
    .stackhub { display: none!important; }
  }
</style>
